import { render, staticRenderFns } from "./AttendanceItem.vue?vue&type=template&id=f0c2fb4a&scoped=true"
import script from "./AttendanceItem.vue?vue&type=script&lang=js"
export * from "./AttendanceItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0c2fb4a",
  null
  
)

export default component.exports